import { useCallback } from 'react';
import { useToast } from '@cad-arc';

export function useCopyText() {
    const toast = useToast();

    return useCallback(
        function copyText({ text, copiedFieldLabel }: { text: string; copiedFieldLabel: string }) {
            navigator.clipboard.writeText(text).then(() => {
                toast({
                    status: 'default',
                    description: `${copiedFieldLabel} copied to clipboard.`,
                });
            });
        },
        [toast]
    );
}
